import React, { useState, useEffect } from 'react';
import Footer from '../Shared/Footer/Footer';
import { Outlet, useLocation } from 'react-router-dom';
import SideNavbar from '../Shared/SideNavbar/SideNavbar';
import HomeNavBar from '../Shared/HomeNavBar/HomeNavBar';
import './AdminOutlet.css'

const AdminOutlet = () => {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const location = useLocation();

    // Handle window resize
    useEffect(() => {
        const handleResize = () => {
            const mobile = window.innerWidth <= 768;
            setIsMobile(mobile);
            if (!mobile) {
                setSidebarOpen(false);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Close sidebar when route changes on mobile
    useEffect(() => {
        if (isMobile) {
            setSidebarOpen(false);
        }
    }, [location.pathname, isMobile]);

    // Handle body scroll when sidebar is open on mobile
    useEffect(() => {
        if (isMobile && sidebarOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }

        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [sidebarOpen, isMobile]);

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    const closeSidebar = () => {
        setSidebarOpen(false);
    };

    return (
        <div>
            <HomeNavBar />
            
            {/* Mobile Sidebar Toggle Button */}
            {isMobile && (
                <button 
                    className="sidebar-toggle" 
                    onClick={toggleSidebar}
                    aria-label="Toggle Sidebar"
                >
                    <i className={sidebarOpen ? 'bi bi-x-lg' : 'bi bi-list'}></i>
                </button>
            )}

            {/* Sidebar Overlay for Mobile */}
            {isMobile && (
                <div 
                    className={`sidebar-overlay ${sidebarOpen ? 'overlay-open' : ''}`}
                    onClick={closeSidebar}
                ></div>
            )}

            {/* Sidebar */}
            <div className={`Admin-SideBar ${sidebarOpen ? 'sidebar-open' : ''}`}>
                <SideNavbar />
            </div>
            
            {/* Main Content */}
            <div className="AdminComponent">
                <Outlet />
            </div>
        </div>
    );
};

export default AdminOutlet;